// Reads the provided file and converts it to an HTML table.
// It relies on the SheetJS library.
//
const parseAndPreview = function (files) {
  let i = 0
  while (i !== files.length) {
    const f = files[i]

    const reader = new FileReader()

    reader.onload = function (e) {
      const data = e.target.result
      const workbook = XLSX.read(data, { type: "binary", raw: true })
      const sheet = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { header: "A", defval: "" })

      processSheet(sheet)
    }

    reader.readAsBinaryString(f)
    ++i
  }
}

// Uses the file converted to an HTML table to build a preview. If the
// table contains only one column, no preview: we immediately write its
// content into the textarea.
//
var processSheet = function (sheet) {
  window.fileContent = sheet

  if (Object.keys(sheet[0]).length === 1) {
    // file has one column only
    $("#preview-container").hide()
    return fillDomainsTextarea("A")
  }

  emptyDomainsTextarea()
  $("#preview-container .horizontal-scroll").html(buildPreviewTable())
  return $("#preview-container").show()
}

var fillDomainsTextarea = function (key) {
  $(".domains-textarea").removeClass("light-grey")
  const domains = getValuesFromColumn(key)
  return $("#bulk_search_domains").val(domains.join("\n"))
}

var emptyDomainsTextarea = function () {
  $("#bulk_search_domains").val("")
}

// Returns an array containing all the values from the column
// at the passed key, in the global var fileContent. No value
// is appended if the cell is empty or we're iterating for the first
// time and the cell contains a keyword (we bet we're reading the headers).
//
var getValuesFromColumn = function (key) {
  const values = []

  window.fileContent.forEach(function (row, row_index) {
    const value = row[key]

    if (value === "") {
      return
    }

    if (
      row_index === 0 &&
      $.inArray(value.toLowerCase(), ["domain", "domain name", "company", "company name", "organization", "website"]) >=
        0
    ) {
      // ignore headers
      return false
    }

    values.push(value)
  })

  return App.removeDuplicateValues(values)
}

// Converts a column name to an index
const columnNameToIndex = function (columnName) {
  let index = 0
  for (let i = 0; i < columnName.length; i++) {
    index = index * 26 + columnName.charCodeAt(i) - "A".charCodeAt(0) + 1
  }
  return index - 1 // Subtract 1 because array indices start at 0
}

// Builds a previous table made of the first 5 rows from the passed file.
//
var buildPreviewTable = function () {
  let previewTable = "<table id='preview-table'>"

  previewTable += "<tr>"

  // Build the headers first
  //Object.values(window.fileContent[0]).forEach(value => console.log(value))
  Object.keys(window.fileContent[0]).forEach(function (key) {
    previewTable += `<th><a class='h-button h-button--primary' data-index="${columnNameToIndex(key)}" data-key="${key}">${i18n.t("js.select")}</th>`
  })

  previewTable += "</tr>"

  window.fileContent.forEach(function (row, index) {
    if (index >= 5) {
      return false
    }

    previewTable += "<tr>"

    Object.values(row).forEach(function (cell) {
      // XSS prevention
      if (/<|>/.test(cell)) {
        cell = encodeURI(cell)
      }

      previewTable += `<td>${cell}</td>`
    })

    previewTable += "</tr>"
  })

  previewTable += "</table>"

  return previewTable
}

// Triggered when the form is submitted
//
const onFormSubmitted = function () {
  document.getElementById("bulk-search-form").addEventListener("turbo:submit-start", function () {
    App.analytics.ga_track("Bulk Domain Search", "Creation")
  })
}

const onPreviewColumnClicked = () =>
  // we have to use a delegation here at the preview table is
  // dynamically generated
  $("#preview-container").delegate("#preview-table th a", "click", function () {
    // we get the key of the clicked column and pass it to
    // the fillDomainsTextarea function
    fillDomainsTextarea($(this).data("key"))
    $("#bulk_search_domains_column_index").val($(this).data("index"))

    return cleanPreview()
  })

var cleanPreview = function () {
  $("#preview-container .content-scroll").html("")
  return $("#preview-container").hide()
}

const disableEmailVerification = function (emailsPerDomain) {
  if (emailsPerDomain <= 10) {
    return $("#bulk_search_verify_emails").prop("disabled", false)
  } else {
    return $("#bulk_search_verify_emails").val("false").prop("disabled", "disabled")
  }
}

document.addEventListener("turbo:load", function () {
  if (!App.currentPageIs("bulk_searches", "new")) {
    return
  }

  $(".file-field").change((e) => parseAndPreview(e.target.files))

  $(".remove-selected-file").on("click", () => cleanPreview())

  $("#bulk_search_emails_per_domain").on("change", (e) => disableEmailVerification(parseInt($(e.target).val())))

  onPreviewColumnClicked()

  return onFormSubmitted()
})
